import { Unit } from "../../business/DataModel";
import {
  METHODS,
  defaultHeaders,
  RESPONSE_CODES,
  API_ENDPOINT,
  FetchResponseType,
} from "../../constants";

const enum RESOURCES {
  units = "units",
}

/**
 * Obtiene la lista de unidades de medida general
 */
export const GetUnits = async () => {
  //>> Composición de URL
  const url = API_ENDPOINT + RESOURCES.units;

  //>> Respuesta
  type Response = FetchResponseType<Unit[]>;
  let DefaultResponse: Unit[];

  const result: Response = await fetch(url, {
    method: METHODS.GET,
    headers: defaultHeaders,
  })
    .then((res) => res.json())
    .then((res: Response) => {
      if (res.result_code != RESPONSE_CODES.SUCCESS) {
        throw new Error("No se ha podido conectar con el servidor");
      }
      return res;
    })
    .catch((error) => {
      console.error(error);
      return { result_code: 400, response: DefaultResponse };
    });

  return result;
};
